import { message } from 'antd';
import { takeLatest, put, select, delay } from 'redux-saga/effects';
import { StoreActionProps } from 'data/core';
import { updateSpaceTabInSpaces } from 'data/templates/projects/slices';
import { logger } from 'services';
import {
  UpdateDocumentTemplateAction,
  updateDocumentTemplateAction,
} from '../actions';
import { normalizeTemplatePayload } from '../api/transform';
import { getDocumentById } from '../selectors';
import { updateDocumentTemplate } from '../slices';
import { DocumentTemplate } from '../types';
import { saveDocumentTemplate } from './_save-template';

function* updateDocumentTemplateSaga(
  action: StoreActionProps<UpdateDocumentTemplateAction>,
) {
  const {
    payload: {
      spaceId,
      spaceTab,
      sync,
      template,
      handleAlways,
      handleFailure,
      handleSuccess,
    },
  } = action;

  try {
    const document: DocumentTemplate = yield select(
      getDocumentById(template.templateId as number),
    );

    let documentTemplate = {
      ...document,
      ...template,
    } as DocumentTemplate;

    yield put(updateDocumentTemplate(documentTemplate));

    if (spaceId && spaceTab) {
      yield put(
        updateSpaceTabInSpaces({
          spaceTab: {
            ...spaceTab,
            spaceTabTitle: documentTemplate.templateName || '',
          },
          spaceId,
        }),
      );
    }

    yield delay(2000);

    documentTemplate = yield saveDocumentTemplate(
      template.templateId as number,
      sync,
    );

    const {
      entities: { template: updatedPayload },
    } = normalizeTemplatePayload(documentTemplate);

    yield put(updateDocumentTemplate(updatedPayload[template.templateId]));

    if (handleSuccess) {
      handleSuccess(documentTemplate);
    }
  } catch (error) {
    logger.error('an error updating the document template', { error });

    message.error('There was an error updating the document template');

    if (handleFailure) {
      handleFailure();
    }
  }

  if (handleAlways) {
    handleAlways();
  }
}

export function* watchUpdateDocumentTemplateSaga(): Generator {
  yield takeLatest(
    updateDocumentTemplateAction.type,
    updateDocumentTemplateSaga,
  );
}
